/* eslint-disable no-unused-vars */
import { PushNotifications } from '../../models/pushNotifications';
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';

export class PushNotificationsApi {
  constructor(private api: ApiClient) {}

  path = '/push-notifications';

  async send(req: FormData) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      this.path + '/send',
      req,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return resp.data;
  }

  async getAll(skip: number, take: number) {
    const resp = await this.api.client.get<NiceResponse<PushNotifications[]>>(
      `${this.path}/sendings?skip=${skip}&take=${take}`,
    );
    return resp.data;
  }
}
